import { ElevationCallouts } from "./layout/ElevationCallouts/ElevationCallouts"
import { ElevationNote } from "./layout/ElevationNote/ElevationNote"
import { NumberAndPage } from "./layout/NumberAndPage/NumberAndPage"
import { Objects } from "./layout/Objects/Objects"
import type { TEcall, TErefWithFurniture, TFurniture } from "types/elevationReferences.type"

type Props = {
	eref: TErefWithFurniture
	ecalls: TEcall[]
	onCommitNote?: (note: string) => void
	onEcallClick?: (ecall: TEcall) => void
	onFurnitureClick?: (furniture: TFurniture) => void
}

export const DetailsTab = ({ eref, ecalls, onCommitNote, onEcallClick, onFurnitureClick }: Props) => {
	return (
		<div>
			<NumberAndPage eref={eref} />
			<ElevationNote comment={eref.estimation_config_comment ?? ""} onCommit={onCommitNote} />
			<Objects eref={eref} onFurnitureClick={onFurnitureClick} />
			<ElevationCallouts key={eref.id} eref={eref} ecalls={ecalls} onEcallClick={onEcallClick} />
		</div>
	)
}
